import React, { useEffect, useState } from "react";
import PrivateRoute from "../PrivateRoute/PrivateRoute";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box } from '@chakra-ui/react'
import { Loading } from "../Loading";
import MyDrive from "../../pages/MyDrive";
import SearchResultWindow from "../SearchResult/SearchResultWindow";
import Notes from "../Notes/Note";
import OracleReaderComponent from "../OracleReaderComponent/OracleReaderComponent";
import Home from "../../pages/Home";
import TermsOfUse from "../../pages/TermsOfUse";
import PrivacyPolicy from "../../pages/PrivacyPolicy";
import Profile from '../../pages/Profile';
import LatexTest from "../LatexTest";
import TaskQATaskView from "../TaskViewer/TaskQATaskView";
import Writer from "../../pages/Writer";
import MyPlanPage from "../../pages/MyPlan";
import ReaderComponent from "../OracleReaderComponent/ReaderComponent";
import PaymentPage from "../../pages/PaymentPage";
import PaymentSuccessPage from '../../pages/PaymentSuccessPage'
import PaymentCurrentPage from '../../pages/PaymentCurrentPage'
import EditorModel from "../../pages/EditorModel";
import PaymentFailurePage from "../../pages/PaymentFailurePage"; // 新增导入
// import EditableTest from "../../pages/WriterTests/Editable";
import PaymentPendingPage from '../../pages/PaymentPendingPage'
import RefundPolicyPage from "../../pages/RefundPolicy";
import Support from "../../pages/Support";
import { useSetRecoilState } from "recoil";
import { getFullAccessModalOpenStatus } from "../../atoms/rootAtom";
import { PaymentService } from "../../services/paymentService";

const EditGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const setFullAccessModalOpen = useSetRecoilState(getFullAccessModalOpenStatus);
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        let cancelled = false;

        async function check() {
            try {
                const result = await PaymentService.getCurrentPlan();
                if (cancelled) return;

                // 只对完全没有plan的用户弹出modal
                // free_plan用户可以访问页面，但点击编辑功能时会通过后端middleware触发modal
                if (result?.plan_type === 'none') {
                    setFullAccessModalOpen(true);
                }
            } catch (error) {
                console.error('Failed to check payment plan:', error);
            } finally {
                if (!cancelled) setChecking(false);
            }
        }

        check();
        return () => { cancelled = true; };
    }, [setFullAccessModalOpen]);

    if (checking) return <Loading isLoading />;
    return <>{children}</>;
};

const MainWrapper = () => {
    return (
        <Box overflow={'hidden'} w='full' h='full'>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Home />} />
                <Route path="/search" element={<PrivateRoute><SearchResultWindow /></PrivateRoute>} />
                <Route path="/read" element={<PrivateRoute><OracleReaderComponent /></PrivateRoute>} >
                    <Route path={"/read/"} element={<TaskQATaskView />} />
                    <Route path={"/read/notes"} element={<Notes />} />
                </Route>
                <Route path="/reader2" element={<PrivateRoute><ReaderComponent /></PrivateRoute>} >
                    <Route path={"/reader2/"} element={<TaskQATaskView />} />
                    <Route path={"/reader2/notes"} element={<Notes />} />
                </Route>
                <Route path="/edit" element={<PrivateRoute><EditGuard><Writer /></EditGuard></PrivateRoute>} />
                <Route path="/edit/:paperId" element={<PrivateRoute><EditGuard><EditorModel /></EditGuard></PrivateRoute>}>
                </Route>
                <Route path="/my-library" element={<PrivateRoute><MyDrive /></PrivateRoute>} />
                <Route path="/terms-of-use" element={<TermsOfUse />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/latex-test" element={<LatexTest />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/my-plan" element={<MyPlanPage />} />
                <Route path="/payment" element={<PaymentPage />} /> {/* Payment Page */}
                <Route path="/payment-success" element={<PaymentSuccessPage />} />
                <Route path="/payment-failure" element={<PaymentFailurePage />} /> {/* 新增支付失败页面路由 */}
                <Route path="/payment-current" element={<PaymentCurrentPage />} />
                <Route path="/payment-pending" element={<PaymentPendingPage />} />
                <Route path="/refund-policy" element={<RefundPolicyPage />} />
                <Route path="/support" element={<Support />} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
            <Loading />
        </Box>
    );
}

export default MainWrapper;
